import apiClient, { unwrap } from './client';

export const inventoryApi = {
  // ── Items ──────────────────────────────────────────────────────────────────

  getAllItems: async () => {
    const res = await apiClient.get('/inventory/items', { params: { size: 1000, sort: 'name,asc' } });
    const page = unwrap(res);
    return page?.content ?? page ?? [];
  },

  createItem: async (item) => {
    const res = await apiClient.post('/inventory/items', item);
    return unwrap(res);
  },

  updateItem: async (id, item) => {
    const res = await apiClient.put(`/inventory/items/${id}`, item);
    return unwrap(res);
  },

  deleteItem: async (id) => {
    await apiClient.delete(`/inventory/items/${id}`);
  },

  // ── Movements ──────────────────────────────────────────────────────────────

  getMovements: async (itemId, page = 0, size = 30) => {
    const res = await apiClient.get(`/inventory/items/${itemId}/movements`, {
      params: { page, size, sort: 'date,desc' },
    });
    const data = unwrap(res);
    return data?.content ?? data ?? [];
  },

  addMovement: async (movement) => {
    const res = await apiClient.post('/inventory/movements', movement);
    return unwrap(res);
  },

  // ── Feed deduction (called automatically after a feed record is created) ──

  deductFeed: async ({ feedType, qtyKg, roomId, flockId, date }) => {
    const res = await apiClient.post('/inventory/movements/feed-deduct', {
      feedType,
      quantity: qtyKg,
      roomId: roomId ?? null,
      flockId: flockId ?? null,
      date,
      source: 'FEED_RECORD',
    });
    return unwrap(res);
  },

  /**
   * Adjust inventory when a feed record is edited.
   * Handles both quantity changes (same type) and feed-type changes.
   */
  adjustFeed: async ({ feedType, quantityDelta, previousFeedType, previousQuantity, roomId, date }) => {
    const res = await apiClient.post('/inventory/movements/feed-adjust', {
      feedType,
      quantityDelta,
      previousFeedType: previousFeedType ?? null,
      previousQuantity: previousQuantity ?? null,
      roomId: roomId ?? null,
      date,
    });
    return unwrap(res);
  },

  // ── Summary (low-stock + expiry alerts) ────────────────────────────────────

  getSummary: async () => {
    const res = await apiClient.get('/inventory/summary');
    return unwrap(res);
  },
};
